module.exports = __webpack_public_path__ + "img/header-memoireRingsWhite@2x.e830d9b.webp";